import { render, staticRenderFns } from "./MyBL.vue?vue&type=template&id=1c282ed4&lang=html&"
import script from "./MyBL.vue?vue&type=script&lang=js&"
export * from "./MyBL.vue?vue&type=script&lang=js&"
import style0 from "./MyBL.vue?vue&type=style&index=0&id=1c282ed4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports